export const SHOW_IDOS_AS_LIST = 'SHOW_IDOS_AS_LIST';
export const SHOW_ADDONS_AS_LIST = 'SHOW_ADDONS_AS_LIST';
